const formatter = (message) => {
  return { message };
};
const singles = {
  extraSeat: "Are you sure you want to add extra seat?",
};

class Messages {
  constructor() {
    this.singles = singles;
  }

  addMessage(name) {
    return { message: `Your ${name} has been added successfully.` };
  }

  removeMessage(name) {
    return { message: `Your ${name} has been removed successfully.` };
  }

  updateMessage(name, item) {
    const end = "has been updated successfully.";
    const message = item
      ? `Your ${name} "${item}" ${end}`
      : `Your ${name} ${end}`;

    return formatter(message);
  }

  extraSeatMessage() {
    return formatter("Extra seat has been added successfully.");
  }

  invoiceCreated() {
    return formatter("Captain invoice created successfully.");
  }

  arriveMessage(name) {
    return formatter(`You marked "${name}" as arrived successfully.`);
  }

  seatsToMaxMessage() {
    return formatter("Bus capacity is the maximum.");
  }

  departMessage(name) {
    return formatter(`You marked "${name}" as departed successfully.`);
  }

  cancelRideMessage() {
    return formatter("Your ride has been cancelled successfully.");
  }

  createManualRideMessage() {
    return formatter("Manual ride created successfully");
  }

  enableRideMessage(name, status) {
    return formatter(`${name} has been ${status}d successfully.`);
  }

  endRideMessage() {
    return formatter("Ride has been ended successfully.");
  }

  emergencyMessage() {
    return formatter("Ride has been flaged as emergency successfully.");
  }

  removeEmergencyMessage() {
    return formatter("Emergency flag has been removed successfully.");
  }

  assignCaptainMessage() {
    return formatter("Captain has been assigned successfully.");
  }

  checkInMessage() {
    return formatter("Your booking has been checked in successfully.");
  }

  checkOutMessage() {
    return formatter("Your booking has been checked out successfully.");
  }

  cancelRefundMessage() {
    return formatter(
      "Your booking has been cancelled and refunded successfully."
    );
  }

  bookMessage() {
    return formatter("Your booking has been created successfully.");
  }

  payMessage() {
    return formatter("Your booking price has been paid successfully.");
  }

  removeSubscriptionMessage() {
    return formatter("Your subscription has been removed successfully.");
  }

  ticketCreatedMessage() {
    return formatter("Your ticker has been created successfully.");
  }

  referOptionsMessage() {
    return formatter("Your refer options have been updated successfully.");
  }

  cancellationPolicy() {
    return formatter(
      "Your cancellation options have been updated successfully."
    );
  }
}

export default Messages;



// WEBPACK FOOTER //
// ./src/services/messages/messages.service.js